import React, { useContext, useEffect, useState } from 'react';
import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  makeStyles,
  Typography,
} from '@material-ui/core';
import { CommentContext } from '../../../../services/meeting-details/meeting-details-comment.context';
import moment from 'moment';

const useStyle = makeStyles(() => {
  return {
    commentReply: {
      margin: 16,
      marginRight: 'auto',
      backgroundColor: '#f1ebbf',
    },
  };
});

export const Reply = ({ reply }) => {
  const classes = useStyle();
  const { users } = useContext(CommentContext);
  const [user, setUser] = useState('');

  //Get the user information of this reply
  const getUser = (users, reply) => {
    return (
      users &&
      users.length > 0 &&
      users.filter((user) => user.uid === reply.user_uuid)
    );
  };

  useEffect(() => {
    setUser(getUser(users, reply)[0]);
  }, [reply, users]);

  return (
    <Card className={classes.commentReply}>
      <CardHeader
        className={classes.cardHeader}
        avatar={
          <Avatar className={classes.commentAvatar} src={user && user.avatar}>
            {user && user.username && user.username[0].toUpperCase()}
          </Avatar>
        }
        title={
          <Typography variant='h6'>
            <em>{user && user.username}</em>
          </Typography>
        }
        subheader={
          <Typography variant='body2' color='textSecondary'>
            <em>
              {reply.submit_date && moment(reply.submit_date).format('MMMM. DD, YYYY, HH:mm A')}
            </em>
          </Typography>
        }
      />
      <CardContent dir='auto'>
        <Typography variant='body2' color='textSecondary'>
          <em>{reply.comment}</em>
        </Typography>
      </CardContent>
    </Card>
  );
};
